import { SxProps, Theme, ToggleButton } from "@mui/material";
import { ApplicationTooltip } from "../views";

type ToolsPanelToggleButtonProps = {
    isActivated: boolean;
    setIsActivated: React.Dispatch<React.SetStateAction<boolean>>;
    tooltipTextWhenActivated: string;
    tooltipTextWhenDeactivated?: string;
    children: React.ReactElement;
    disabled?: boolean;
    sx?: SxProps<Theme>;
};

export function ToolsPanelToggleButton({
    isActivated,
    setIsActivated,
    tooltipTextWhenActivated,
    tooltipTextWhenDeactivated = '',
    children,
    disabled = false,
    sx = undefined,
}: ToolsPanelToggleButtonProps) {
    const toggleButtonSx: SxProps<Theme> = [
        {
            borderColor: "#9e9d9d",
            '&.Mui-selected': {
                backgroundColor: '#FACC2D',
                borderColor: '#36454B',
                color: '#36454B',
                '&:hover': {
                    backgroundColor: '#f4bf00',
                },
            },
            '&.Mui-selected.Mui-disabled': {
                backgroundColor: 'transparent',
                color: 'rgba(0,0,0,0.26)',
                borderColor: "#9e9d9d",
            },
            '&.Mui-disabled svg': {
                color: 'rgba(0,0,0,0.26)'
            },
            height: '5px',
            width: '5px',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ];

    return (
        <ApplicationTooltip
            disableInteractive
            title={
                isActivated
                    ? tooltipTextWhenActivated
                    : tooltipTextWhenDeactivated
            }
        >
            <ToggleButton
                value="check"
                selected={isActivated}
                onChange={() => setIsActivated(!isActivated)}
                sx={toggleButtonSx}
                disabled={disabled}
            >
                {children}
            </ToggleButton>
        </ApplicationTooltip>
    )
}
